module.exports = __webpack_public_path__ + "img/sneek-1.31ec092a.jpg";